var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#BE2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0935 37.4058L49.813 38.8749C49.5523 40.2505 48.266 41.1741 46.8097 41.0339L43.9097 40.7534C42.6475 40.6316 41.5708 39.7334 41.2492 38.5349L40.3553 35.1986C39.0307 34.6561 37.5716 34.4081 35.9778 34.4535C34.4429 34.4869 32.9303 34.828 31.5295 35.4565L30.9742 38.5802C30.7645 39.7646 29.7884 40.6471 28.5517 40.7718L25.6687 41.0608C24.2294 41.2053 22.851 40.2901 22.443 38.9216L22.0038 37.4511C21.5675 35.9906 21.9571 34.4521 23.0252 33.4136C25.5483 30.9628 29.7544 29.7331 35.6435 29.7246C41.5425 29.7176 45.8789 30.9387 48.6556 33.391C49.8243 34.4223 50.3697 35.9495 50.0935 37.4058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeave);
export default __webpack_public_path__ + "static/media/icon-leave.ba41e877c00f0001510baf124ef67700.svg";
export { ForwardRef as ReactComponent };